import React from 'react';
import { Cushion, FlexContainer, ShimmerAvatar, ShimmerTypography } from '@pitchero/react-ui';

const ProfilePlaceholder = () => (
  <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
    <ShimmerAvatar size={48} />
    <Cushion horizontal="medium" style={{ flex: 1 }}>
      <ShimmerTypography preset="subtitle--small" width="90%" />
      <ShimmerTypography preset="body--small" width="80%" />
    </Cushion>
  </FlexContainer>
);

export default ProfilePlaceholder;
